import React from 'react';
import {fetchUtils, Button, SimpleForm, Filter, BooleanInput, required, Toolbar, SaveButton,
  DateField, Edit, Create, List, Datagrid, TextField, TextInput, SelectArrayInput, FormDataConsumer,
  ReferenceArrayInput, AutocompleteArrayInput, SelectInput, DateInput} from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
const moment = require('moment');

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/ad_malware_report';

const choicesInterval = [
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
	{ id: 'custom', name: 'Custom' }
];
function defaultStartDate() {
	let ret = new Date();
	ret.setTime(ret.getTime() - 8*24*3600*1000);
	return ret;
}
function defaultEndDate() {
	return new Date();
}
function formatDate(date) {
	return date.toISOString().slice(0, 10);
}
const showChoices = [
  { id: 'date', name: 'Date' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'adomain', name: 'Advertiser Domain' },
  { id: 'tldomain', name: 'Domain' },
  { id: 'block_type', name: 'Block Type' }
];

const AdMalwareTitle = ({ record }) => {
  return <span>Advertiser Malware Report {record ? `"${record.report_name}"` : ''}</span>;
};
const AdMalwareFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const AdMalwareReportList = (props) => (
  <List {...props} title="Advertiser Malware Reports" perPage={25} bulkActionButtons={false} filters={<AdMalwareFilter />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="report_name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);
class CustomToolbar extends React.Component {
  state = {
  }
  constructor(props) {
    super(props);
    this.parent = props.parent;
  }
  fetchData() {
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    let interval = (formData.interval) ? `&interval=${formData.interval}` : '&interval=day';
		let dateRange = '';
		if (formData.date_range === 'custom') {
			let startDate = (typeof formData.start_date === 'object') ? formatDate(formData.start_date) : formData.start_date;
			let endDate = (typeof formData.end_date === 'object') ? formatDate(formData.end_date) : formData.end_date;
			dateRange = `&start_date=${startDate}&end_date=${endDate}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

    this.parent.setState({loading: true, total: '---'});
    let url = `${BASE_URL}?${show}${interval}${dateRange}`+
    `${utils.formDataFieldsQueryStringFormat(formData, ['publisher_id', 'bidder_id', 'tldomain', 'adomain'])}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => (
      this.parent.setState({data: json.data, loading: false, total: json.total})
    ));
  }
  handleSearch = () => {
    this.fetchData();
  }

  render() {
    return <Toolbar>
      <SaveButton style={{marginRight: '25px'}} variant='contained' 
        color='primary' disabled={this.props.parent.state.loading} {...this.props} />
      <br />
      <Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
        startIcon={<RunReportIcon />} style={{marginRight: '5px', padding: '7px', width: '160px'}} 
        disabled={this.props.parent.state.loading} />
      <br />
      {this.parent.props.formType==='edit' &&
        <span>
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
        </span>
      }
    </Toolbar>
  }
};
let formData = {};
function setFormData(formdata) {
  formData = formdata;
}
class AdMalwareForm extends React.Component {
  state = {
		date_range : this.props.record.date_range
	};
  render() {
    return (
      <SimpleForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
        <TextInput source="report_name" label="Report Name" style={{ width: '400px' }} validate={required()} />
        <FormDataConsumer>
          {({ formData }) => setFormData(formData) }
        </FormDataConsumer>
        <div style={{ display: 'flex', columnGap: '5px' }} id="wrapper3">
          <div style={{ flex: 1 }}>
            <SelectInput label="Interval" source="interval"
            choices={choicesInterval}
            defaultValue='day'
            disabled={this.props.parent.loading} />
          </div>
          <div style={{ flex: 1 }}>
              <SelectInput label="Date Range" source="date_range"
              onChange={value => this.setState({ date_range: value.target.value })}
              choices={dateRangeChoices}
              defaultValue="8"
              disabled={this.props.parent.loading} />
          </div>

          <div style={{ flex: 1, display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
            <DateInput label="Start Date" source="start_date" allowEmpty
            disabled={this.props.parent.loading}
            initialValue={defaultStartDate()}
            style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <DateInput label="End Date" source="end_date" allowEmpty
            disabled={this.props.parent.loading}
            initialValue={defaultEndDate()}
            style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}
            />
          </div>

          <div style={{ flex: 1 }}>
            <SelectArrayInput label="Show"
            source="show"
            choices={showChoices}
            style={{ width: '400px' }}
            disabled={this.props.parent.loading} />
          </div>
        </div>
        <div style={{ width: '60%', display: 'flex', columnGap: '5px' }} id="wrapper3">     
          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="bidder_id"
              label="Bidders"
              reference="bidders"
              basePath="bidders"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading} 
                optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                optionValue="code"
                fullWidth
              />
            </ReferenceArrayInput>
          </div>

          <div>
            <TextInput source="adomain" label="Advertiser Domain" disabled={this.props.parent.loading}
            style={{width: '300px'}} />
          </div>

          <div>
            <TextInput source="tldomain" label="Site Domain" disabled={this.props.parent.loading}
            style={{width: '300px'}} />
          </div>

        </div>
      </SimpleForm>
    )
  }
}
let BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true, cell: row => <span>{ `${row.bidder_name} (${row.bidder_id})` }</span> },
  { name: 'Domain', selector: 'tldomain', sortable: true },
  { name: 'Ad Domain', selector: 'adomain', sortable: true },
  { name: 'Block Type', selector: 'block_type', sortable: true },
  { name: 'Blocks', selector: 'blocks', sortable: true, cell: row => utils.formatLong(row.blocks, ' ') },
  { name: 'Impressions', selector: 'impressions', sortable: true, cell: row => utils.formatLong(row.impressions, ' ') },
  { name: '%Block Rate', selector: 'block_rate', sortable: true, cell: row => utils.formatDouble(row.block_rate/1000, ' ', 3) }
];
let columns = [];

class AdMalwareUpsert extends React.Component {
  state = {
    data: [],
    loading: false,
    total: '---'
  };
  setState(obj) {
    if (obj.data && obj.data.length>0) {
      let keys = Object.keys(obj.data[0]);
      columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
    }
    super.setState(obj);
  }
  render() {
    const { data, loading, total } = this.state;
    return (
    <div>
      {this.props.formType === "edit" &&
        <Edit title={<AdMalwareTitle />} {...this.props}>
          <AdMalwareForm formType="edit" permissions={this.props.permissions} parent={this}/>
        </Edit>
      }
      {this.props.formType === "create" &&
        <Create title="Create Advertiser Malware Report" {...this.props}>
          <AdMalwareForm formType="create" permissions={this.props.permissions} parent={this}/>
        </Create>
      }
      <DataTable
        title={`${total} Matching Results`}
        theme={window.nobid_table_theme()}
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        fixedHeader
        dense
        paginationPerPage={30}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        subHeader={!loading}
        subHeaderComponent={
          (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input type="text" id='search_box' label="Search"
            variant="outlined"
            style={{ margin: '5px' }}
            onChange={(target) => dataSupport.filterData(this)} />
            <CloudDownload
            label="Export"
            style={{ margin: '5px' }}
            color="action"
            onClick={() => dataSupport.exportData(this.state.data)}
            />
          </div>
          )
        }
      />
    </div>
    )
  }
}

export const AdMalwareReportEdit = ({permissions, ...props}) => (
  <AdMalwareUpsert formType="edit" permissions={permissions} {...props} />
);

export const AdMalwareReportCreate = ({permissions, ...props}) => (
  <AdMalwareUpsert formType="create" permissions={permissions} {...props} />
);